<template>
  <svg
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="66" y="108" width="210" height="24" rx="12" />
    <rect x="384" y="108" width="62" height="24" rx="12" />
    <path
      fill-rule="evenodd"
      d="M288 120 a42 42 0 1 0 84 0 a42 42 0 1 0 -84 0 z M314 120 a16 16 0 1 1 32 0 a16 16 0 1 1 -32 0 z"
    />
    <rect x="66" y="244" width="60" height="24" rx="12" />
    <rect x="234" y="244" width="212" height="24" rx="12" />
    <path
      fill-rule="evenodd"
      d="M138 256 a42 42 0 1 0 84 0 a42 42 0 1 0 -84 0 z M164 256 a16 16 0 1 1 32 0 a16 16 0 1 1 -32 0 z"
    />
    <rect x="66" y="380" width="160" height="24" rx="12" />
    <rect x="334" y="380" width="112" height="24" rx="12" />
    <path
      fill-rule="evenodd"
      d="M238 392 a42 42 0 1 0 84 0 a42 42 0 1 0 -84 0 z M264 392 a16 16 0 1 1 32 0 a16 16 0 1 1 -32 0 z"
    />
  </svg>
</template>
